import React, { useEffect, useState } from 'react';
import { Sparkles, Package, BarChart3, Clock } from 'lucide-react';

const MESSAGES = [
  { icon: Package, label: 'Approvisionnement en cours' },
  { icon: BarChart3, label: 'Analyse des spécifications' },
  { icon: Clock, label: 'Bientôt disponible' },
  { icon: Sparkles, label: 'Mise à jour du catalogue' },
];

const ROTATION_MS = 2600;

export default function ComingSoonOverlay({ variant = 'card' }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % MESSAGES.length), ROTATION_MS);
    return () => clearInterval(id);
  }, []);

  const Icon = MESSAGES[idx].icon;
  const label = MESSAGES[idx].label;

  if (variant === 'detail') {
    // Bloc ardoise foncée (navy du site) cohérent avec le fond photo coming-soon et le
    // hero — icône + shimmer cyan, texte blanc. Choix boss 2026-06-01 (premium).
    return (
      <div className="relative overflow-hidden rounded-sm border border-secondary/30 bg-primary px-4 py-3 coming-soon-shimmer">
        <div className="flex items-center gap-3">
          <Icon
            key={`icon-${idx}`}
            className="w-5 h-5 text-secondary shrink-0"
            strokeWidth={2.2}
            style={{ animation: 'fade-rotate 0.4s ease-out' }}
          />
          <span
            key={`label-${idx}`}
            className="font-heading font-semibold text-sm uppercase tracking-wider text-white"
            style={{ animation: 'fade-rotate 0.4s ease-out' }}
          >
            {label}
          </span>
        </div>
      </div>
    );
  }

  // variant === 'card' — petit bandeau dans la card produit (catalogue)
  return (
    <div className="absolute bottom-0 left-0 right-0 z-10 pointer-events-none">
      <div className="relative overflow-hidden bg-gradient-to-t from-primary/95 via-primary/85 to-transparent px-3 pt-5 pb-2 coming-soon-shimmer">
        <div className="relative z-10 flex items-center gap-1.5">
          <Icon className="w-3 h-3 text-secondary shrink-0" strokeWidth={2.5} />
          <span
            key={idx}
            className="font-accent text-[10px] font-bold uppercase tracking-wider text-white truncate"
            style={{ animation: 'fade-rotate 0.4s ease-out' }}
          >
            {label}
          </span>
        </div>
      </div>
    </div>
  );
}
